import { IJsPhoneLib } from './jsphonelib-types';
import { JsPhoneLib } from './jsphonelib';

export * from './jsphonelib-types';

export var jsPhoneLib: IJsPhoneLib = new JsPhoneLib();
